export default __webpack_public_path__ + "static/media/eduix_logo_2000x734_orange.3d245b8c.png";